import React__default, { useEffect } from 'react';
import './Modal.scss.js';
import { createPortal } from 'react-dom';
import { classnames } from '../../../utils/classnames.js';
import Button from '../Button/Button.js';
import AllClose from '../../../assets/icons/resultDir/AllClose.js';

var Modal = function Modal(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      header = _ref.header,
      footer = _ref.footer,
      _ref$custom = _ref.custom,
      custom = _ref$custom === void 0 ? false : _ref$custom,
      _ref$showLine = _ref.showLine,
      showLine = _ref$showLine === void 0 ? true : _ref$showLine,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'modal' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'xxl' : _ref$size;

  /** При маунте добавляем модалку. При дестрое - удаляем. */
  useEffect(function () {
    /** Закрывает модалку при нажатии на Escape */
    var closeOnEscPress = function closeOnEscPress(e) {
      if (e.key === 'Escape' && onClose) {
        onClose();
      }
    };

    document.body.style.overflowY = 'hidden';
    window.addEventListener('keyup', closeOnEscPress);
    return function () {
      document.body.style.overflowY = 'auto';
      window.removeEventListener('keyup', closeOnEscPress);
    };
  }, []);
  /** Обертка для модалки */

  var modal = /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "rf-modal",
    className: classnames('rf-modal', "rf-modal--".concat(variant), "rf-modal--".concat(size), showLine && 'rf-modal__footer--line'),
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "rf-modal__bg",
    onClick: onClose,
    "data-v-6e52f9c7": ""
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "rf-modal__container",
    "data-v-6e52f9c7": ""
  }, onClose && /*#__PURE__*/React__default.createElement(Button, {
    buttonType: "text",
    textColor: "neutral",
    startAdornment: /*#__PURE__*/React__default.createElement(AllClose, {
      "data-v-6e52f9c7": ""
    }),
    className: "rf-modal__close-button",
    onClick: onClose,
    "data-v-6e52f9c7": ""
  }), custom ? children : /*#__PURE__*/React__default.createElement("div", {
    className: "rf-modal__wrapper",
    "data-v-6e52f9c7": ""
  }, header && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-modal__header",
    "data-v-6e52f9c7": ""
  }, header), /*#__PURE__*/React__default.createElement("div", {
    className: "rf-modal__content",
    "data-v-6e52f9c7": ""
  }, children), footer && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-modal__footer",
    "data-v-6e52f9c7": ""
  }, footer))));
  return /*#__PURE__*/createPortal(modal, document.body);
};

export { Modal as default };
